"use client";

import React from "react";
import { SectionContentProps } from "../../types";
import EditableText from "../../core/EditableText";
import { PiArrowRight, PiLightning } from "react-icons/pi";

export default function SaasHero({ content, onContentChange, isSelected }: SectionContentProps) {
  const fontFamily = content.fontFamily || "'Inter', sans-serif";

  const updateContent = (key: string, value: any) => {
    onContentChange?.({ ...content, [key]: value });
  };

  return (
    <div
      className={`relative overflow-hidden py-32 bg-slate-950 text-white text-center ${isSelected ? "ring-2 ring-blue-500 relative z-20" : ""}`}
      style={{ fontFamily }}
    >
      {/* Background glow effects */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-blue-600/10 rounded-full blur-[120px] pointer-events-none" />

      <div className="max-w-4xl mx-auto px-6 space-y-8 relative z-10">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-slate-900 border border-slate-800 text-xs font-semibold text-blue-400">
          <PiLightning className="w-4 h-4 text-blue-400" />
          <span>Introducing AI Automation</span>
        </div>

        <h1 className="text-4xl sm:text-6xl font-extrabold tracking-tight text-white leading-tight">
          <EditableText
            value={content.title || "Scale your business with AI"}
            onChange={(val) => updateContent("title", val)}
            as="span"
          />
        </h1>

        <p className="text-lg sm:text-xl text-slate-400 max-w-2xl mx-auto leading-relaxed">
          <EditableText
            value={content.subtitle || "The all-in-one platform for modern enterprises to automate operations."}
            onChange={(val) => updateContent("subtitle", val)}
            as="span"
          />
        </p>

        <div className="flex flex-wrap justify-center gap-4 pt-4">
          <a
            href={content.primaryBtnLink || "#signup"}
            className="px-6 py-3 rounded-lg bg-blue-600 hover:bg-blue-700 text-white font-semibold text-sm shadow transition-all flex items-center gap-2"
          >
            {content.primaryCta || "Get Started"}
            <PiArrowRight className="w-4 h-4" />
          </a>
          <a
            href={content.secondaryBtnLink || "#demo"}
            className="px-6 py-3 rounded-lg bg-slate-900 border border-slate-800 hover:bg-slate-850 text-white font-semibold text-sm transition-all"
          >
            {content.secondaryCta || "Book Demo"}
          </a>
        </div>
      </div>
    </div>
  );
}
